import { LOGOUT } from '../constants/authConstants';
import * as types from '../constants/specificationsConstants';

const initialState = {
  loading: true,
  transmissionTypes: [],
  wheelDriveTypes: [],
  fuelTypes: [],
  colorTypes: [],
};

const specificationsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...initialState,
      };
    case types.CLEAR_SPECIFICATIONS:
      return {
        ...initialState,
      };
    case types.GET_SPECIFICATIONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_SPECIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        transmissionTypes: payload.transmissionTypes,
        wheelDriveTypes: payload.wheelDriveTypes,
        fuelTypes: payload.fuelTypes,
        colorTypes: payload.colorTypes,
      };

    case types.GET_SPECIFICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default specificationsReducer;
